module.exports = __webpack_public_path__ + "img/INDUSTRIA_02_prew.2dc01a5f.jpg";